import { useRecoilState, useRecoilValue } from "recoil";
import { BannersAnalyticsInfoModalBase } from "./BannersAnalyticsInfoModal";
import { analyticsMenuBannerInfoModalStore } from "../stores/analyticsBanners";
import { userStore } from "../stores/access";

function MenuBannersAnalyticsInfoModal(props) {
	const [bannerInfo, setBannerInfo] = useRecoilState(analyticsMenuBannerInfoModalStore);
	const user = useRecoilValue(userStore);
	const brandList = user.brandsList || [];

	return (
		<BannersAnalyticsInfoModalBase
			{...props}
			bannerInfo={bannerInfo}
			brandList={brandList}
			loadAnalyticsInfo={(name, date, products) => props.Interface.loadHomeBannerAnalyticsInfo(name, date, products)}
			setBannerInfo={setBannerInfo}
		/>
	);
}

export default MenuBannersAnalyticsInfoModal;
